import React from 'react';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import { ReactComponent as Instant } from '../../../assets/img/Instant.svg';
import { ReactComponent as Rethinking } from '../../../assets/img/Rethinking_workspace.svg';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import { ReactComponent as ShowPassword } from '../../../assets/icons/show.svg';
import { ReactComponent as HidePassword } from '../../../assets/icons/hide.svg';
import styles from './LoginPopupMain.module.scss';

const LoginPopupMain = () => {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [error, setError] = React.useState('');
  const recaptchaRef = React.useRef(null);

  const handleClick = () => {
    document.querySelector('[class*="LoginPopupMain_background"]')?.setAttribute('style', 'display: none');
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.body.style.paddingRight = '0';
  };

  const handleLoginCoworker = (e:any) => {
    e.preventDefault();
    e.stopPropagation();
    // @ts-ignore
    recaptchaRef.current.execute('6LcaVKAUAAAAAAfDTPgFv8tGuwrodh_Mv6_eJ0oT', { action: 'validateNavLogin_a' }).then((captchaToken) => {
      let baseUrlEl = document.getElementById('base_url');
      // @ts-ignore
      baseUrlEl = baseUrlEl === null ? false : baseUrlEl.value;
      // @ts-ignore
      const baseUrl = `${baseUrlEl || sysVars.baseURL}validate_navlogin`;

      const data = {
        semail: email,
        spass: password,
        form_login: 1,
        msg_log: 0,
        captchaToken,
      };

      axios({
        method: 'post',
        url: baseUrl,
        data,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then((response) => {
          if (response.data.msg === 'SCS') {
            // going to another page instead of reload so as not to lose form data
            const createSpaceButton = document.querySelector('#user_space_form .add-coworking-space-form-submit input');
            if (window.location.pathname === '/list-space' && createSpaceButton  instanceof HTMLInputElement) {
              createSpaceButton.click(); 
            } else {
              // eslint-disable-next-line
              location.reload();
            }
          } else {
            setError(response.data.error);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  const handleForgotPass = () => {
    const forgotPassButton = document.querySelector('#rest-password-button');
    if (forgotPassButton) {
      document.querySelector('[class*="LoginPopupMain_background"]')?.setAttribute('style', 'display: none');
      // @ts-ignore
      forgotPassButton.click();
    }
  };

  const handleSignUp = (e:any) => {
    e.preventDefault();
    const sumbitButton = document.querySelector('.header-signup-link');
    if (sumbitButton) {
      document.querySelector('[class*="LoginPopupMain_background"]')?.setAttribute('style', 'display: none');
      // @ts-ignore
      sumbitButton.click();
    }
  };

  const stopBubbling = (e:any) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.background} onClick={handleClick} style={{ display: 'none' }}>
      <div className={styles.container} onClick={(e) => stopBubbling(e)}>
        <ReCAPTCHA ref={recaptchaRef} sitekey="6LcaVKAUAAAAAAfDTPgFv8tGuwrodh_Mv6_eJ0oT" size="invisible" />
        <button
          className={styles.closeButton}
          data-cy="modal-close-button"
          onClick={handleClick}
          type="button"
        >
          <CloseIcon className={styles.closeIcon} />
        </button>
        <form className={styles.content}>
          <div className={styles.header}>
            Log in and explore Coworker
          </div>
          <div className={styles.inputContainer}>
            <input id="email" onChange={(e) => setEmail(e.target.value)} pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" placeholder="Email Address" required type="email" value={email} />
            <label htmlFor="email">Email Address</label>
          </div>
          <div className={styles.inputContainer}>
            <input id="password" minLength={3} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required type={passwordVisible ? 'text' : 'password'} value={password} />
            <label htmlFor="password">Password</label>
            {!!error.length && (
            <div className={styles.errorMessage}>
              <p>{error}</p>
            </div>
            )}
            <span onClick={() => setPasswordVisible(!passwordVisible)}>
              {passwordVisible ? <HidePassword /> : <ShowPassword />}
            </span>
          </div>
          <div className={styles.checkboxContainer}>
            <div>
              <label>
                <input type="checkbox" />
                <span className={styles.customCheckbox} />
              </label>
              <span className={styles.customCheckboxText}>Remember Me</span>
            </div>
            <span className={styles.forgotPass} onClick={handleForgotPass}>Forgot Password</span>
          </div>
          <div className={styles.btnContainer}>
            <button className={styles.button} onClick={handleLoginCoworker} type="submit">Login</button>
          </div>
          <div className={styles.signUp}>
            <span>Don&apos;t have an account?</span>
            <button onClick={handleSignUp} type="submit">Sign up</button>
          </div>
          <div className={styles.footer}>
            <div>
              Powered by the
            </div>
            <div>
              <div><Instant /></div>
              <div><Rethinking /></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPopupMain;
